import React from 'react';

import { BackboneReplacer } from '@core/js/backbone/components/BackboneReplacer';
import { Icon } from '@core/js/components/common/Icon';
import { Link } from '@core/js/components/common/Link';

import { useOpenChat, useOpenInbox } from '@core/js/components/system/CommunicationWidgets/hooks';

import { useGetAvailableMenuItems } from '@interlayer/js/custom/components/main/NavigationBar/hooks/useGetAvailableMenuItems';
import { useCheckIsActiveLink } from '@interlayer/js/custom/hooks/useMenu';

import style from './NavigationBar.scss';

export const NavigationBar = ({ currentPageURL }) => {
    const checkIsActiveLink = useCheckIsActiveLink(currentPageURL);
    const currentMenuItems = useGetAvailableMenuItems(currentPageURL);
    const hasActivePage = (pages) => pages?.some((page) => checkIsActiveLink(page.url));

    const onOpenInbox = useOpenInbox();
    const onOpenChat = useOpenChat();

    if (!currentMenuItems.length) {
        return null;
    }

    return (
        <div className={`${style.container} cms-navigation-bar`}>
            <ul className={style.list}>
                {currentMenuItems.map(item => (
                    <div key={item.url} className={`${style.listItem_wrapper} ${checkIsActiveLink(item.url) ? `${style.isActive} active` : ''}`} >
                        {item.inboxOpener && (
                            <li className={`${style.listItem} ${item.cssClasses ? `${item.cssClasses} ` : ''}`}>
                                <a
                                    href='#'
                                    className={`${style.listItemPoint} ${style.listItemPointReplacer}`}
                                    onClick={onOpenInbox}
                                >
                                    <div className={style.replacerContainer}>
                                        <span className={`${style.itemName} ${style.replacerItem}`}>{item.name}</span>
                                        <BackboneReplacer
                                            dynamicName={'UNREAD_MESSAGES_COUNT'}
                                            viewName={'unreadmessagescount'}
                                        />
                                    </div>
                                </a>
                            </li>
                        )}
                        {item.chatOpener && (
                            <li className={`${style.listItem} ${item.cssClasses ? `${item.cssClasses} ` : ''}`}>
                                <a
                                    href='#'
                                    className={`${style.listItemPoint} ${style.listItemPointReplacer} ${checkIsActiveLink(item.url) ? `${style.isActive} active` : ''}`}
                                    onClick={onOpenChat}
                                >
                                    <div className={style.replacerContainer}>
                                        <Icon type={item.menuIcon}/>
                                        <span className={`${style.itemName} ${style.replacerItem}`}>{item.name}</span>
                                        <BackboneReplacer dynamicName={'CHAT_UNREAD'} viewName={'chatunread'} />
                                    </div>
                                </a>
                            </li>
                        )}
                        {!item.inboxOpener && !item.chatOpener && (
                            <li
                                className={
                                    `${style.listItem} ${item.cssClasses ? `${item.cssClasses} ` : ''}${checkIsActiveLink(item.url) && !item.children ? `${style.isActive} active` : ''}`
                                }
                                data-url={item.url}
                            >
                                <Link
                                    href={item.url}
                                    inNewWindow={item.target === '_blank'}
                                    className={`${style.link} ${style.listItemPoint} ${hasActivePage(item.children) ? `${style.isActive} active` : ''}`}
                                >
                                    <Icon
                                        type={item.menuIcon}
                                        className={style.icon}
                                    />
                                    <span className={style.itemName}>{item.name}</span>
                                </Link>
                                {item.children && (
                                    <ul
                                        className={`${style.subMenu} ${hasActivePage(item.children) ? `${style.isActive}` : ''}` }
                                    >
                                        {item.children.map((subItem) => (
                                            <li className={`${style.subMenuItem}`} key={subItem.url}>
                                                <Link
                                                    href={subItem.url}
                                                    inNewWindow={subItem.target === '_blank'}
                                                    className={`${style.subMenuItemLink} ${style.listItemPoint} ${checkIsActiveLink(subItem.url) ? style.isActive : ''}`}
                                                >
                                                    <Icon type={subItem.menuIcon}/>
                                                    <span className={style.itemName}>{subItem.name}</span>
                                                </Link>
                                            </li>
                                        ))
                                        }
                                    </ul>
                                )}
                            </li>
                        )}
                    </div>
                ))}
            </ul>
        </div>
    );
};
